import { useContext } from 'react'
import { AppContext } from '../../contextApi/ContextApi';

export default function AdminClientCard({client, theme}) {
    const {calculateDaysPassed, formatDate} = useContext(AppContext);
  return (
    <div className='adminClientCard' dir='rtl' style={{backgroundColor:theme.accent_color, color:theme.primary_color}}>
        <table>
            <thead>
                <tr>
                    <th>שם משתמש</th>
                    <th>אימייל</th>
                    <th>פלאפון</th>
                    <th>תאריך הרשמה</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{client.name}</td>
                    <td>
                        {/* <a href={`mailto:${client.email}?subject=Webingo%20Support&body=Hey%20there%20${client.name},%20We%20want%20to%20inform%20you%20about...`}>
                        {client.email}
                        </a> */}
                        <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${client.email}&su=Webingo%20Support&body=Hey%20there%20${client.name},%20We%20want%20to%20inform%20you%20about...`} target="_blank">
                        {client.email}
                        </a>
                    </td>
                    <td>{client.phone}</td>
                    <td>{formatDate(client.createdAt)} ({calculateDaysPassed(client.createdAt)} ימים)</td>
                </tr>
            </tbody>
        </table>
    </div>
  )
}
